/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logout_PlaceholderInputs */

const id_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /auth/logout!`)
};

const ms_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /auth/logout!`)
};

const da_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /auth/logout!`)
};

const de_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /auth/logout!`)
};

const en_us2_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /auth/logout!`)
};

const es_es2_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /auth/logout!`)
};

const es_mx2_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /auth/logout!`)
};

const fil_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /auth/logout!`)
};

const fr_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour /auth/logout !`)
};

const it_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao /auth/logout!`)
};

const hu_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szia /auth/logout!`)
};

const nl_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /auth/logout!`)
};

const no_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /auth/logout!`)
};

const pl_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witaj /auth/logout!`)
};

const pt_br2_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /auth/logout!`)
};

const pt_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /auth/logout!`)
};

const ro_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salut /auth/logout!`)
};

const fi_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /auth/logout!`)
};

const sv_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /auth/logout!`)
};

const vi_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin chào /auth/logout!`)
};

const tr_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba /auth/logout!`)
};

const cs_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahoj /auth/logout!`)
};

const bg_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здравейте /auth/logout!`)
};

const ru_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет, /auth/logout!`)
};

const uk_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привіт /auth/logout!`)
};

const ar_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا /auth/logout!`)
};

const hi_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमस्ते /auth/logout!`)
};

const th_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวัสดี /auth/logout!`)
};

const ja_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こんにちは /auth/logout!`)
};

const zh_cn2_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /auth/logout!`)
};

const zh_hant1_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /auth/logout！`)
};

const ko_auth_logout_placeholder = /** @type {(inputs: Auth_Logout_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/auth/logout에 오신 것을 환영합니다!`)
};

/**
* | output |
* | --- |
* | "Hello /auth/logout!" |
*
* @param {Auth_Logout_PlaceholderInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const auth_logout_placeholder = /** @type {((inputs?: Auth_Logout_PlaceholderInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logout_PlaceholderInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_auth_logout_placeholder(inputs)
	if (locale === "ms") return ms_auth_logout_placeholder(inputs)
	if (locale === "da") return da_auth_logout_placeholder(inputs)
	if (locale === "de") return de_auth_logout_placeholder(inputs)
	if (locale === "en-US") return en_us2_auth_logout_placeholder(inputs)
	if (locale === "es-ES") return es_es2_auth_logout_placeholder(inputs)
	if (locale === "es-MX") return es_mx2_auth_logout_placeholder(inputs)
	if (locale === "fil") return fil_auth_logout_placeholder(inputs)
	if (locale === "fr") return fr_auth_logout_placeholder(inputs)
	if (locale === "it") return it_auth_logout_placeholder(inputs)
	if (locale === "hu") return hu_auth_logout_placeholder(inputs)
	if (locale === "nl") return nl_auth_logout_placeholder(inputs)
	if (locale === "no") return no_auth_logout_placeholder(inputs)
	if (locale === "pl") return pl_auth_logout_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_auth_logout_placeholder(inputs)
	if (locale === "pt") return pt_auth_logout_placeholder(inputs)
	if (locale === "ro") return ro_auth_logout_placeholder(inputs)
	if (locale === "fi") return fi_auth_logout_placeholder(inputs)
	if (locale === "sv") return sv_auth_logout_placeholder(inputs)
	if (locale === "vi") return vi_auth_logout_placeholder(inputs)
	if (locale === "tr") return tr_auth_logout_placeholder(inputs)
	if (locale === "cs") return cs_auth_logout_placeholder(inputs)
	if (locale === "bg") return bg_auth_logout_placeholder(inputs)
	if (locale === "ru") return ru_auth_logout_placeholder(inputs)
	if (locale === "uk") return uk_auth_logout_placeholder(inputs)
	if (locale === "ar") return ar_auth_logout_placeholder(inputs)
	if (locale === "hi") return hi_auth_logout_placeholder(inputs)
	if (locale === "th") return th_auth_logout_placeholder(inputs)
	if (locale === "ja") return ja_auth_logout_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_auth_logout_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_auth_logout_placeholder(inputs)
	return ko_auth_logout_placeholder(inputs)
});
export { auth_logout_placeholder as "auth.logout.placeholder" }